/**
 * @nanokart/tryon-studio-sdk
 * useSession hook - Studio session info (simplified, no OTP/auth)
 */

import { useMemo } from 'react';
import { useStore } from './useStore';

export interface UseSessionReturn {
  sessionId: string | null;
  status: 'idle' | 'active' | 'ended';
  startedAt: string | null;
  stats: { tryonsGenerated: number; momentsGenerated: number };
  isActive: boolean;
  duration: number;
  endSession: (reason?: string) => void;
}

export function useSession(): UseSessionReturn {
  const sessionId = useStore((s) => s.studioSession.id);
  const status = useStore((s) => s.studioSession.status);
  const startedAt = useStore((s) => s.studioSession.startedAt);
  const stats = useStore((s) => s.studioSession.stats);
  const endSessionAction = useStore((s) => s.endSession);

  const isActive = status === 'active';

  const duration = useMemo(() => {
    if (!startedAt) return 0;
    return Math.floor((Date.now() - new Date(startedAt).getTime()) / 1000);
  }, [startedAt]);

  return { sessionId, status, startedAt, stats, isActive, duration, endSession: endSessionAction };
}
